import React from "react";
import { Box, Typography } from "@mui/material";
import Field from "../shared/Field";

const FormContact = ({ data, onChange }) => (
  <Box>
    <Box
      mb={2}
      p={1.5}
      sx={{
        background: "rgba(59,130,246,0.08)",
        border: "1px solid rgba(59,130,246,0.25)",
        borderRadius: "8px",
      }}
    >
      <Typography variant="caption" color="warning.main">
        ℹ️ The contact form fields are static. Only heading and subheading are
        customizable here.
      </Typography>
    </Box>
    <Field
      label="Section Heading"
      value={data.heading}
      onChange={(v) => onChange({ ...data, heading: v })}
      placeholder="Ready To Build Your MERN App?"
    />
    <Field
      label="Section Subheading"
      value={data.subheading}
      onChange={(v) => onChange({ ...data, subheading: v })}
      multiline
      placeholder="Have a full-stack project in mind?..."
    />
    <Field
      label="Submit Button Text"
      value={data.submitBtnText}
      onChange={(v) => onChange({ ...data, submitBtnText: v })}
      placeholder="Submit Inquiry"
    />
  </Box>
);

export default FormContact;
